import FetchFactory from '../factory';

const CONTROLLER_PATH = '/api-electra/Porting/';
const DEV_CONTROLLER_PATH = '/api-electra/Development/';

class PortingModule extends FetchFactory<any> {
  /**
   * Return a delivery address
   * @param asyncDataOptions options for `useAsyncData`
   * @returns
   */

  async sendPortingCode(shoppingCartItemId: number, phoneNumber: string) {
    const url = `${CONTROLLER_PATH}SendPortingCode`;
    return await this.call('POST', url, {
      ShoppingCartItemId: shoppingCartItemId,
      PhoneNumber: phoneNumber,
    });
  }

  async devGetPortingCode(phoneNumber: string) {
    const RESOURCE = `${DEV_CONTROLLER_PATH}DevGetPortingCode`;
    return await this.call('POST', `${RESOURCE}`, {
      PhoneNumber: phoneNumber,
    });
  }

  async validatePortingCode(portingCode: string, phoneNumber: string) {
    const url = `${CONTROLLER_PATH}ValidatePortingCode`;
    return await this.call('POST', url, {
      PortingCode: portingCode,
      PhoneNumber: phoneNumber,
    });
  }
}

export default PortingModule;
